export const DOWNLOAD = 'download'
export const IMPORT = 'import'
export const DELETE = 'delete'
export const EXPORT = 'export'
export const SCENARIO = 'scenario'

export const IMPORT_ERROR = 'IMPORT_ERROR'
export const IMPORT_SUCCESS = 'IMPORT_SUCCESS'

export const UPLOAD_ERROR = 'UPLOAD_ERROR'
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS'

export const DELETE_ERROR = 'DELETE_ERROR'
export const DELETE_SUCCESS = 'DELETE_SUCCESS'

export const EXPORT_ERROR = 'EXPORT_ERROR'
export const EXPORT_SUCCESS = 'EXPORT_SUCCESS'

export const MIN_TIME = 8000

export const mapAutomated = {
  export: true,
  scenario: false
}

export const ctasMap = {
  REDIRECT: 'redirect',
  OPENMODAL: 'openModal',
  DOWNLOAD: 'download'
}
